import { GitBranch } from 'lucide-react';
import { cn } from '@/lib/utils';

export function Logo({ className }: { className?: string }) {
  return (
    <GitBranch className={cn("text-primary", className)} />
  );
}
